// src/components/dashboard/AlertDashboard.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";

const AlertDashboard: React.FC = () => {
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    const fetchAlert = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/usuarios/dashboard/alert`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });

        // Verifica se existe a chave message
        if (res.data && res.data.message) {
          setMessage(res.data.message);
        }
      } catch (error: any) {
        // Se for 204 No Content, não considera erro
        if (error.response && error.response.status === 204) {
          setMessage(""); // sem alerta
        } else {
          console.error("Erro ao buscar alerta:", error);
        }
      }
    };

    fetchAlert();
  }, []);

  if (!message) return null;

  return (
    <div className="alert alert-teal alert-dismissible d-flex align-items-center border-0 mb-4 fade show">
      <i className="isax isax-info-circle5 me-2" />
      {message}
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      >
        <i className="fas fa-xmark" />
      </button>
    </div>
  );
};

export default AlertDashboard;